// Application-specific functions.
// Use either Vue.extend() or a Vue component with an empty template if the reactivity feature becomes necessary.
import flat from 'flat';
import configuration from 'utils/configuration';

export async function setLocale (locale) {
  let app = this;

  // TODO: Implement fallback to supportedCultures list.
  if (app.$i18n.locale === locale) {
    return;
  }

  try {
	let localeMessages = await configuration.loadLocaleMessages(app.$hrefBase + "resources?v=" + (Math.random() + 1).toString().slice(2));
    let unflattenedLocaleMessages = flat.unflatten(localeMessages, { delimiter: ':' });

    // TODO: Verify if we really need to allow tenant overrides of validation messages.
    if (unflattenedLocaleMessages.validation.messages) {
      localeMessages.validation = {
        "messages": unflattenedLocaleMessages.validation.messages["vee-validate"],
        "custom": unflattenedLocaleMessages.validation.messages["vee-validate"]["custom"]
      };
    }

    app.$i18n.setLocaleMessage(locale, localeMessages);

    app.$i18n.locale = locale;
  } catch (error) {
    console.log(error);
  }
}
